import { roundNumber } from '../../roundNumber';

export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

function vec3FromTuple([x, y, z]: [number, number, number]): Vec3 {
  return { x: roundNumber(x), y: roundNumber(y), z: roundNumber(z) };
}

export default vec3FromTuple;
